export const GET_REGION = 'MACHINERY_OWNER/get_region';
export const GET_PROVINCE = 'MACHINERY_OWNER/get_provinces';
export const GET_MUNICIPALITIES = 'MACHINERY_OWNER/get_municipalities';
export const GET_BARANGAYS = 'MACHINERY_OWNER/get_barangays';

export const GET_MACHINERY_OWNER = '/get_machinery_owner';
export const GET_SINGLE_MACHINERY_OWNER = '/get_single_machinery_owner';
export const UPDATE_MACHINERY_OWNER = '/update_machinery_owner';
export const CREATE_MACHINERY_OWNER = '/create_machinery_owner';
export const REMOVE_MACHINERY_OWNER = '/remove_machinery_owner';

export const FORM_DATA = {
  first_name: '',
  middle_name: '',
  last_name: '',
  suffix: '',
  status: '',
  authorized_representative: '',
  region_code: '',
  province_code: '',
  municipality_code: '',
  barangay_code: '',
  address_line: '',
  telephone_no: '',
  tin: '',
  mobile_number: '',
  email: '',
};
